export type Opacity = Readonly<{
  /**0: 0 */
  0: number;
  /**1: 0.01 */
  1: number;
  /**50: 0.06 */
  50: number;
  /**100: 0.09 */
  100: number;
  /**200: 0.12 */
  200: number;
  /**300: 0.18 */
  300: number;
  /**400: 0.24 */
  400: number;
  /**500: 0.32 */
  500: number;
  /**600: 0.48 */
  600: number;
  /**700: 0.56 */
  700: number;
  /**800: 0.64 */
  800: number;
  /**900: 0.72 */
  900: number;
  /**1000: 0.8 */
  1000: number;
  /**1100: 0.88 */
  1100: number;
  /**1200: 0.94 */
  1200: number;
  /**1300: 1.0 */
  1300: number;
}>;

export const opacity: Opacity = {
  0: 0.0,
  1: 0.01,
  50: 0.06,
  100: 0.09,
  200: 0.12,
  300: 0.18,
  400: 0.24,
  500: 0.32,
  600: 0.48,
  700: 0.56,
  800: 0.64,
  900: 0.72,
  1000: 0.8,
  1100: 0.88,
  1200: 0.94,
  1300: 1.0,
};
